/**
 * Processes a heading string by trimming specified text and conditionally adding it back.
 * @param {Object} options - Configuration options.
 * @param {string} options.headingText - The heading string to process.
 * @param {string} options.trimText - The text to remove from the heading (default: '(optional)').
 * @param {boolean} options.shouldAppend - Whether to append the trimmed text back (default: false).
 * @param {boolean} options.isRequired - Whether the item is required (only matters if shouldAppend is true).
 * @returns {string} The processed heading.
 */
export function processSlotHeading({
  headingText,
  trimText = '',
  shouldAppend = false,
  isRequired = false
}) {
  // Early return if no heading provided.
  if (!headingText) return '';

  // Remove the specified text from the heading.
  const rawHeading = headingText
    ?.replace(trimText, '')
    .trim();

  // If we should add back the trimmed text, do so based on the isRequired flag.
  // Otherwise, return the raw heading.
  return shouldAppend && !isRequired
    ? `${rawHeading} ${trimText}`.trim()
    : rawHeading;
}
